module.exports = __webpack_public_path__ + "static/img/shuili_3.dc26ab6e.png";